"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTransfer = void 0;
const router_1 = require("next/router");
const fdr_lib_router_target_page_data_1 = require("@hotelplan/fdr.lib.router.target-page-data");
const useTransfer = () => {
    const { push } = (0, router_1.useRouter)();
    return {
        transfer: (link, shallow = false, toTop = true) => {
            const { href, as, locale } = (0, fdr_lib_router_target_page_data_1.targetPageData)(link);
            push(href, as, {
                shallow,
                scroll: toTop,
                locale,
            });
        },
        targetPageData: fdr_lib_router_target_page_data_1.targetPageData,
    };
};
exports.useTransfer = useTransfer;
//# sourceMappingURL=index.js.map